export enum OrderStatus {
    Processing,
    Requested,
    Completed
}